import { LockOutlined } from "@mui/icons-material";
import {
  Container,
  CssBaseline,
  Box,
  Avatar,
  Typography,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch } from "../hooks/redux-hooks";
import { driverLogin } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { useTranslation } from "react-i18next";

const Login = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    localStorage.removeItem("userInfo");
  }, []);

  const handleDriverLogin = async () => {
    if (email && password) {
      dispatch(
        driverLogin({
          email,
          password,
        })
      );
      localStorage.removeItem('driverOrdersSelectedDate');
    } else {
      dispatch(
        showNotification({
          message: "Please provide email and password",
          type: NotificationType.Error,
        })
      );
    }
  };

  return (
    <>
      <Container maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            mt: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.light" }}>
            <LockOutlined />
          </Avatar>
          <Typography variant="h5">{t("driverLogin")}</Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={t("emailAddress")}
              name="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              id="password"
              name="password"
              label={t("password")}
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleDriverLogin}
            >
              {t("login")}
            </Button>
            {/* 添加忘记密码链接 */}
            {/* <Grid container justifyContent="flex-end">
               <Grid item>
                <MuiLink
                  component={RouterLink}
                  to="/forgot-password"
                  sx={{
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  {t("forgotPassword")}
                </MuiLink>
              </Grid>
            </Grid> */}
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link to="/forgot-password?type=driver" style={{ textDecoration: 'none' }}>
                  {t("forgotPassword")}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Login;
